export const prioritySortCalloutHeading = "mSCYUc";
export const prioritySortCalloutDescription = "IYVgXb";
export const prioritySortCalloutSecondaryButtonText = "$OJ1D";
export const prioritySortCalloutTryNowText = "C3qTsb";
export default {prioritySortCalloutHeading,prioritySortCalloutDescription,prioritySortCalloutSecondaryButtonText,prioritySortCalloutTryNowText};